import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { CrewService } from '../services/crew.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setCrewLicensuresOptions } from '../store/crew.actions'
import { ICrewLicensuresResponse, ICrewLicensuresOptionsArr, ICrewLicensuresOptions } from '../store/crew.types'

export function* getCrewLicensures() {
  const serviceId: string = yield select(getServiceIdSelector)
  const crewService = new CrewService(serviceId)
  try {
    const crewStateListResponse: ICrewLicensuresResponse = yield call([crewService, crewService.getCrewStateLicensures])
    const crewNationalListResponse: ICrewLicensuresResponse = yield call([
      crewService,
      crewService.getCrewNationalLicensures,
    ])
    const stateLicensures: ICrewLicensuresOptionsArr = crewStateListResponse?.entity || []
    const nationalLicensures: ICrewLicensuresOptionsArr = crewNationalListResponse?.entity || []
    const combined: ICrewLicensuresOptionsArr = [...stateLicensures]

    for (const nationalLicensure of nationalLicensures) {
      const matchingIndex = combined.findIndex(
        (stateLicensures: ICrewLicensuresOptions) => stateLicensures.userId === nationalLicensure.userId
      )

      if (matchingIndex !== -1) {
        combined[matchingIndex]?.licensures?.push(...nationalLicensure.licensures)
      } else {
        combined.push(nationalLicensure)
      }
    }
    yield put(setCrewLicensuresOptions(combined))
  } catch (e) {
    yield put(throwPcrException(`getCrewLicensures() error: ${e}`))
  }
}

export function* getCrewLicensuresSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCrewLicensures)
}
